// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Saved Views (BN25)
// ══════════════════════════════════════════════════════
function renderSavedViewsTab() {
  var views = (S.savedViews || []).slice()
  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px"><h2 style="font-size:20px;font-weight:700">Saved Views</h2><div class="spacer"></div>' +
    '<button class="btn btn-primary btn-sm" onclick="openModal(\'addSavedView\')">' + ICONS.plus + ' Save Current View</button></div>' +
    (views.length === 0 ? '<div class="card"><div class="empty-state" style="padding:48px"><div class="empty-icon">\uD83D\uDD0D</div><p>No saved views</p><span>Save filter/sort combinations for quick access. Examples: "Expiring &lt;90 Days", "GH Axis Labs", "Active Protocols".</span></div></div>' :
      views.map(function(v) {
        return '<div class="card" style="margin-bottom:8px;padding:12px;cursor:pointer" onclick="applySavedView(\'' + v.id + '\')">' +
          '<div style="display:flex;align-items:center;gap:8px">' +
            '<div style="flex:1"><div style="font-size:13px;font-weight:600">' + esc(v.name) + '</div>' +
            '<div style="font-size:11px;color:var(--text4)">' + esc(v.module || '') + ' \u00B7 ' + Object.keys(v.filters || {}).length + ' filter(s)</div></div>' +
            '<button class="btn btn-danger btn-xs" onclick="event.stopPropagation();deleteSavedView(\'' + v.id + '\')">' + ICONS.trash + '</button>' +
          '</div></div>'
      }).join('')) +
  '</div>'
}
function saveSavedView() {
  var name = (document.getElementById('sv-name') || {}).value || ''
  if (!name) { showToast('Name required'); return }
  S.savedViews.push({ id: uid(), module: S.tab, name: name, filters: {}, sort: '', columns: [], density: S._densityMode || 'comfortable' })
  save(); closeModal(); showToast('View saved'); render()
}
function applySavedView(id) {
  var v = (S.savedViews || []).find(function(sv) { return sv.id === id })
  if (v && v.module) { setTab(v.module); showToast('View: ' + v.name) }
}
function deleteSavedView(id) { S.savedViews = (S.savedViews || []).filter(function(v) { return v.id !== id }); save(); render() }
export { renderSavedViewsTab, saveSavedView, applySavedView, deleteSavedView }
